module.exports = {
    RECEIVE_ALL_STATE: 'RECEIVE_ALL_STATE',
}
